import { ReactNode, useCallback, useState } from 'react';
import { AuthProvider, UserRole } from '@hssoft/auth-web-shared-lib';

import i18n from '../../i18n/init';
import { C_Language } from '../../graphql/generatedModel';
import { storageHelper } from '../helpers/storage';
import { AuthLanguageContext, LOCALE_TO_C_LANGUAGE, readStoredLocale } from './authLanguage';

const REQUIRED_ROLES: UserRole[] = ['admin', 'company'];

interface AuthShellProps {
  children: ReactNode;
}

// Hosts AuthProvider together with the language state that drives both the auth
// library's form locale and the language selector rendered on the sign-in screen.
// Lives above the router so a language picked before login carries into the app.
export const AuthShell = ({ children }: AuthShellProps) => {
  const [selectedLanguage, setSelectedLanguage] = useState<string>(readStoredLocale);

  const onLanguageChange = useCallback((locale: string) => {
    setSelectedLanguage(locale);
    void i18n.changeLanguage(locale);
    storageHelper.local.setItem(
      'sys_data.language',
      LOCALE_TO_C_LANGUAGE[locale] ?? C_Language.L2_GERMAN,
    );
  }, []);

  return (
    <AuthProvider requiredRole={REQUIRED_ROLES} locale={selectedLanguage}>
      <AuthLanguageContext.Provider value={{ selectedLanguage, onLanguageChange }}>
        {children}
      </AuthLanguageContext.Provider>
    </AuthProvider>
  );
};
